import './CategoryView.scss'
import {Button, Container} from "react-bootstrap";
import {useState} from "react";
import CategoryQuiz from "./CategoryQuiz";
import {BsChevronLeft} from "react-icons/bs";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export default function PracticeView({ currentCat, setCurrentCat }) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const questions = currentCat.questions

    const [course, setCourse] = useState({
        showQuiz: true
    })

    const closeCategory = () => {
        setCourse({
            showQuiz: false
        })
        setCurrentCat(null)
        navigate('/practice', { replace: true })
    }

    return <div id="category-window">
        <div className="category-window-inner">
            <header className="category-header">
                <Container className="d-flex justify-content-start gap-5 align-items-start">
                    <Button onClick={closeCategory} variant="secondary" className="d-flex align-items-center gap-2">
                        <BsChevronLeft /> {t('button.back')}
                    </Button>
                    <div>
                        <h6 className="title">{t('practice')}</h6>
                        <h1 className="title" dangerouslySetInnerHTML={{__html: currentCat.name}} />
                        <p>
                            {currentCat.description}
                        </p>
                    </div>
                </Container>
            </header>
            <Container>
                <section id="category-main">
                    {questions.length > 0 && <CategoryQuiz setCourse={setCourse} course={course} setCurrentCat={setCurrentCat} currentCat={currentCat} isPractice={true} />}
                </section>
            </Container>
        </div>
    </div>
}